const nomineeReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default nomineeReducer;